import { callAPI } from "../../_common/Api";

export default function callApi1333(skin, storeId, language, orderTimestamp, deviceTypeId) {
  return callAPI(skin, "info_vxl_1333", {
    params: [language, "1333", "mqid", "mqpass", storeId, deviceTypeId, "", orderTimestamp],
    id: "1333",
  });
}
